import React from "react";
import { Route } from "react-router-dom";
import { all_routes } from "./all_routes";



// Auth 
import Signin from "../feature-module/pages/login/signin";
import Error404 from "../feature-module/pages/errorpages/error404";
import Error500 from "../feature-module/pages/errorpages/error500";


// modules overview 
import ModulesDashboard from "../feature-module/pages/ModulesDashboard";
import Dashboard from "../feature-module/dashboard/Dashboard";
import SalesDashbaord from "../feature-module/dashboard/salesdashbaord";
import Profile from "../feature-module/pages/profile";


// product screen
import ProductList from "../feature-module/inventory/productlist";
import AddProduct from "../feature-module/inventory/addproduct";
import { Units } from "../feature-module/inventory/units";
import ExpiredProduct from "../feature-module/inventory/expiredproduct";
import LowStock from "../feature-module/inventory/lowstock";
import CategoryList from "../feature-module/inventory/categorylist";
import StockMove from "../feature-module/inventory/stockMove";


// user management screen 
import Users from "../feature-module/usermanagement/users";



const routes = all_routes;
const allRole = ["Manager", "Econome", "Serveur", "Cuisiner", "Barman", "Caissier"];
const inventoryRole = ["Manager", "Econome"];
const stockMovRole = ["Manager", "Econome", "Barman"];

const Dashrole =  ["Manager"];

export const privateRoutes = [
  {
    id: 1,
    path: routes.dashboard,
    name: "home",
    element: <Dashboard />,
    route: Route,
    roles: Dashrole,
  },
  {
    id: 2,
    path: routes.productlist,
    name: "products",
    element: <ProductList />,
    roles: inventoryRole,
  },
  {
    id: 3,
    path: routes.addproduct,
    name: "products",
    element: <AddProduct />,
    route: Route,
    roles: inventoryRole,

  },
  {
    id: 4,
    path: routes.salesdashboard,
    name: "salesdashboard",
    element: <SalesDashbaord />,
    route: Route,
    roles: inventoryRole,

  },

  {
    id: 6,
    path: routes.units,
    name: "unit",
    element: <Units />,
    route: Route,
    roles: inventoryRole,

  },

  {
    id: 58,
    path: routes.expiredproduct,
    name: "expiredproduct",
    element: <ExpiredProduct />,
    route: Route,
    roles: inventoryRole,

  },

  {
    id: 65,
    path: routes.stockmove,
    name: "stockmove",
    element: <StockMove />,
    route: Route,
    roles: stockMovRole,

  },
  {
    id: 59,
    path: routes.lowstock,
    name: "lowstock",
    element: <LowStock />,
    route: Route,
    roles: inventoryRole,

  },
  {
    id: 60,
    path: routes.categorylist,
    name: "categorylist",
    element: <CategoryList />,
    route: Route,
    roles: inventoryRole,

  },
  {
    id: 104,
    path: routes.users,
    name: "users",
    element: <Users />,
    route: Route,
    roles: Dashrole,

  },

 
  
];


export const posRoutes = [
 
  {
    id: 1,
    path: routes.allmodule,
    name: "home",
    element: <ModulesDashboard />,
    route: Route,
    role : allRole,
    
  },
  {
    id: 2,
    path: routes.profile,
    name: "profile",
    element: <Profile />,
    route: Route,
    role : allRole,

  },

];


// Page without login
export const publicRoutes = [
  {
    id: 1,
    path: routes.signin,
    name: "signin",
    element: <Signin />,
    route: Route,
  },
  
  {
    id: 4,
    path: routes.error404,
    name: "NotFound",
    element: <Error404 />,
    route: Route,
    
  },
  {
    id: 5,
    path: routes.error404,
    name: "error500",
    element: <Error500 />,
    route: Route,
  },
  
  {
    id: 8,
    path: '/',
    name: "signin",
    element: <Signin />,
    route: Route,
  },
];
